"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cropBitMatrix = void 0;
var utils_1 = require("../../../utils");
var cropBitMatrix = function (target, cropRect) {
    return target.withMutations(function (bitmt) {
        var width = cropRect.width, height = cropRect.height, top = cropRect.top, left = cropRect.left;
        bitmt.set('width', width);
        bitmt.set('height', height);
        bitmt.update('data', function (data) {
            var dataCropped = new Uint8Array(width * height);
            for (var y = 0; y < height; ++y) {
                for (var x = 0; x < width; ++x) {
                    dataCropped[y * width + x] = data.get((y + top) * target.width + (x + left), 0);
                }
            }
            return (0, utils_1.ReadonlyBitArray)(dataCropped);
        });
    });
};
exports.cropBitMatrix = cropBitMatrix;
